<template>
<div ref="addressselect" v-bind="$attrs">
      <v-list-item class="px-0 dense">
        <v-list-item-action class="mr-2" v-if="!$vuetify.breakpoint.mobile && address && address.name">
            <v-btn icon @click="resetMe"><v-icon>close</v-icon></v-btn>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title v-if="address && address.name" class="primary--text"
          :class="{'text-h6 font-weight-light' : !$vuetify.breakpoint.mobile}"
          >{{search || address.name}}</v-list-item-title>
          <v-list-item-title v-else>
          <vuetify-google-autocomplete :outlined="outlined"
              id="map"
              ref="address"
              v-model="search" 
              :prepend-icon="icon"
              clearable dense
              :autofocus="autofocus"
              hide-details
              auto-select-first
              :placeholder="placeholder"
              v-on:placechanged="getAddressData"
              country="nl"
              @blur="onBlur"
              @focus="focusMe"             
          >
          </vuetify-google-autocomplete>
        </v-list-item-title>
          </v-list-item-content>  
        <v-list-item-action v-if="address && search && !address.number" class="px-0 mx-0" style="width:140px">         
            <v-text-field v-model="number" autofocus dense hide-details solo flat placeholder="NR"
            class="pa-0 ma-0 addressnumber" outlined width="50" type="number" hide-spin-buttons
            >
              <template v-slot:append-outer>
                <v-btn class="success py-4" depressed @click="setNumber" style="margin-top:-7px;height:42px">OK</v-btn>
              </template>
            </v-text-field>
            
        </v-list-item-action>
         <v-list-item-action v-if="showCurrent && !address && !$vuetify.breakpoint.mobile">
           <v-btn text color="primary" @click="getCurrentLocation" ><v-icon left >pin_drop</v-icon>
            <span>Gebruik mijn locatie</span></v-btn>
         </v-list-item-action>
      </v-list-item>
          <center v-if="showCurrent && !address && $vuetify.breakpoint.mobile"><v-btn text color="primary"  @click="getCurrentLocation" ><v-icon left >pin_drop</v-icon>
            <span>Gebruik mijn locatie</span></v-btn></center>
    </div>
</template>

<script>
import locationService from '@/modules/locationService'
export default {
  mixins: [locationService],
  props: {
    value: {
      type: Object,
      default: function () {
        return null
      },
    },
    autofocus: {
      type: Boolean,
      default: function () {
        return false
      },
    },
    autoselect: {
      type: Boolean,
      default: function () {
        return false
      },
    },
    showCurrent: {
      type: Boolean,
      default: function () {
        return false
      },
    },
    placeholder: {
      type: String,
      default: function () {
        return "Zoek op adres bv Voorstraat 22, Klundert"   
      },
    },
    icon: {
      type: String,
      default: function () {
        return null   
      },
    },
    autofocus: {
      type: Boolean,
      default: function () {
        return false
      },
    },
    outlined: {
      type: Boolean,
      default: function () {
        return false
      },
    },
  },
   data: () => ({
     loading: false,
     timer: null,
     address:null,
      zipcode: null,
      number: null,
      hint: null,
      search: null,
      hasfocus: false
  }),
  computed: {
    addresslist(){
      let list = this.listings
      //if (this.allowCurrent) list.push(this.current)
      return list
    },
    name (){
      if (!this.address) return null
      return [this.address.street,this.address.number ,this.address.addition,",",this.address.city].filter(a=>a!=undefined).join(' ').replace(' , ',', ')
    },
    isValid(){
      if (!this.address) return false
      if (!this.address.zipcode) return false
      if (!this.address.number) return false
      return true
    }
  },
  async mounted(){
    this.hasfocus = false
    this.address = this.value
    this.$nextTick(()=>{
         //this.$set(this.address,'zipcode',this.baseZip)
      if (this.$refs.address && this.address) this.$refs.address.update(this.address.name)
      try{
        if (this.$refs.address && this.autofocus) this.$refs.address.focus()
      }catch(e){}
    })
  },
  watch: {
    isValid(value){
      this.address = value
      if (this.address) this.address.name = this.name
    },
    number(value){
      if (value) this.search = this.address.name.replace(', ',' ' + value + ", ")
    },
    listings (value){
      
      //if (value.length == 0 && this.search) this.hint == 'Geen adressen gevonden'
    },
    search(value){
      this.$emit('search', value)
    }
  },
  methods: {
    /*checkTimed() {
      this.loading = true
      if (this.timer) clearTimeout(this.timer)
      this.timer = setTimeout(() => this.getAdres(), 500)
    },
    async getAdres(){
        this.loading = false
        this.address = await this.getAddressSearch({zipcode: this.zipcode, number:this.number})
        if (this.autoselect) this.$emit('select', this.address)
    },*/
     getAddressData(address, place){
       
       if (!address) return false
      if (!address.postal_code){
        let zip = place.address_components.filter(ac=>ac.types && ac.types.includes('postal_code'))[0]
        if (zip) address.postal_code = zip.long_name
      }
      this.address = 
      {
        "zipcode": address.postal_code,
        "coordinate": [
          address.latitude,
          address.longitude
        ],
        "current": false,
        "county": address.country,
        "city": address.locality,
        "name": "Molenstraat 9, Klundert",
        "street": address.route || address.name,
        "number": address.street_number,
        "addition": address.street_addition,
        "region": address.administrative_area_level_1,
        "token": address.place_id,
      }
      this.address.name = this.name
      this.selectMe(this.address)
      //this.$emit('input', this.search)
    },
 
    resetMe(){
      this.zipcode = null
      this.number = null
      this.address = null
    },
    cancel(){
      this.$emit('cancel')
    },
    focusMe(){
      this.hasfocus = true
      if (this.$refs.addressselect) this.$vuetify.goTo(this.$refs.addressselect, {duration: 500, offset: 120})
      this.$emit('focus')
    },
    onBlur(){
      this.hasfocus = false
      if (!this.address || !this.search || this.search.length < 3) this.$emit('cancel')
    },
    checkSearch(address){
     //if (address && address._key == 'current') return this.getCurrentLocation()
        this.selectMe(address)
    },
    async getCurrentLocation(){
        let address = await this.getLocation()
        if (!address) return alert('Zet je locatie aan om deze functie te gebruiken')
        this.selectMe(address)
    },
    selectMe(address){
      address = address || this.address
      if (!address || !address.zipcode) return false
      this.address = address
      this.address.name = this.name
      this.finish()
    },
    setNumber(){
      this.address.number = this.number
      this.address.name = this.name
      return this.finish()
    },
    finish(){
      this.search = this.address.name
      if (!this.isValid) return false
      this.$emit('input', this.address)
      this.$emit('select', this.address)
      this.resetMe()
    },
    updateError() {
      console.log('error');
    }
  }
}
function setCaretPosition(elemId, caretPos) {
    var elem = document.getElementById(elemId);
     if(elem != null) {
        if(elem.createTextRange) {
            var range = elem.createTextRange();
            range.move('character', caretPos);
            range.select();
        }
        else {
            if(elem.selectionStart) {
                elem.focus();
                elem.setSelectionRange(caretPos, caretPos);
            }
            else
                elem.focus();
        }
    }
}
</script>
<style>
.pac-item {
  padding: 8px 4px;
}
.pac-item, .pac-item-query, .pac-matched{
  font-size:1em;
}
</style>